import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CloseFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM8.66906 16.0674C8.27384 16.0674 7.94739 15.7448 7.94739 15.3358C7.94739 15.1429 8.02486 14.9705 8.16152 14.8251L10.9728 12.0126L8.16152 9.20017C8.02486 9.05473 7.94739 8.88228 7.94739 8.68938C7.94739 8.28049 8.27384 7.97522 8.66906 7.97522C8.8832 7.97522 9.03426 8.04402 9.18353 8.18467L11.9957 10.998L14.8339 8.17596C14.988 8.0266 15.1468 7.9578 15.3396 7.9578C15.7436 7.9578 16.07 8.27178 16.07 8.67196C16.07 8.87357 16.01 9.03731 15.8472 9.19145L13.0272 12.0126L15.8385 14.8164C15.9925 14.9618 16.0613 15.1343 16.0613 15.3358C16.0613 15.7448 15.7349 16.0674 15.3222 16.0674C15.1207 16.0674 14.9396 15.9986 14.799 15.8493L11.9957 13.0359L9.20095 15.8493C9.06038 15.9986 8.8832 16.0674 8.66906 16.0674Z"
        fill={color}
      />
    </svg>
  );
};

export { CloseFilledSvg };
